export const ATTENDEE_PRINT_NAVIGATION_VERSION = 1;
export const ATTENDEE_PRINT_NAVIGATION_TTL_MS = 2 * 60 * 1000;
export const ATTENDEE_PRINT_LAYOUT_SAFETY_PX = 4;

const cssPixels = (value) => {
  const parsed = Number.parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export function getPrintContentAvailableHeight(contentHeight, style = {}, safetyPx = ATTENDEE_PRINT_LAYOUT_SAFETY_PX) {
  const height = Number(contentHeight);
  if (!Number.isFinite(height) || height <= 0) throw new Error('Altura do conteúdo inválida para impressão.');
  const verticalPadding = cssPixels(style.paddingTop) + cssPixels(style.paddingBottom);
  return Math.max(1, Math.floor(height - verticalPadding - Math.max(0, Number(safetyPx) || 0)));
}

export function getPrintBlockOuterHeight(measuredHeight, style = {}) {
  const height = Number(measuredHeight);
  if (!Number.isFinite(height) || height <= 0) throw new Error('Altura do bloco inválida para impressão.');
  return Math.ceil(height + cssPixels(style.marginTop) + cssPixels(style.marginBottom));
}

export function paginateMeasuredBlocks(blocks = [], availableHeight) {
  if (!Number.isFinite(availableHeight) || availableHeight <= 0) throw new Error('Altura disponível inválida para paginação.');
  const pages = [];
  let current = { id: 'page-1', fragments: [], blocks: [], usedHeight: 0 };
  const push = () => { if (current.fragments.length) pages.push(current); current = { id: `page-${pages.length + 1}`, fragments: [], blocks: [], usedHeight: 0 }; };
  const add = (fragment) => { current.fragments.push(fragment); current.blocks.push(fragment); current.usedHeight += Number(fragment.measuredHeight ?? fragment.height ?? 0); };
  blocks.forEach((block) => {
    const height = Number(block.measuredHeight ?? block.height ?? 0);
    if (!Number.isFinite(height) || height <= 0) throw new Error(`Bloco ${block.id || 'sem-id'} sem altura mensurável.`);
    if (height > availableHeight) throw new Error(`Bloco ${block.title || block.id || 'sem-id'} excedeu a área imprimível.`);
    if (current.usedHeight + height > availableHeight) push();
    add({ ...block, measuredHeight: height });
  });
  push();
  return pages.map((page, index) => ({ ...page, id: `page-${index + 1}` }));
}

export function splitTextByMeasuredFragments(text, fits) {
  const words = Array.from(String(text || '').matchAll(/\S+|\s+/gu), (m) => m[0]);
  const chunks = [];
  let remaining = words;
  while (remaining.length) {
    let lo = 1, hi = remaining.length, best = 0;
    while (lo <= hi) {
      const mid = Math.floor((lo + hi) / 2);
      const candidate = remaining.slice(0, mid).join('');
      if (fits(candidate)) { best = mid; lo = mid + 1; } else hi = mid - 1;
    }
    if (!best) throw new Error('Texto excede a área imprimível sem ponto seguro de quebra.');
    chunks.push(remaining.slice(0, best).join(''));
    remaining = remaining.slice(best);
  }
  return chunks.map((value) => value);
}

export function createAttendeePrintNavigationToken({ state, activeTab, attendeeTab, attendeeId, now = Date.now(), nonce }) {
  const safeAttendeeId = String(attendeeId || '').trim();
  if (!safeAttendeeId || !/^\d+$/.test(safeAttendeeId)) throw new Error('Atendido inválido para restauração da impressão.');
  const browserCrypto = typeof window !== 'undefined' ? window.crypto : undefined;
  const generatedNonce = browserCrypto?.randomUUID?.() || `${now.toString(36)}-${Math.random().toString(36).slice(2)}`;
  return { version: ATTENDEE_PRINT_NAVIGATION_VERSION, state, activeTab, attendeeTab, attendeeId: safeAttendeeId, createdAt: now, expiresAt: now + ATTENDEE_PRINT_NAVIGATION_TTL_MS, nonce: nonce || generatedNonce };
}

export function readAttendeePrintNavigationToken(storage, key, { now = Date.now(), allowedStates = ['attendee-management:attendees'], allowedActiveTabs = ['attendees'], allowedAttendeeTabs = [] } = {}) {
  try {
    const parsed = JSON.parse(storage.getItem(key) || 'null');
    const customTab = /^custom-\d+$/.test(String(parsed?.attendeeTab || ''));
    const valid = parsed && parsed.version === ATTENDEE_PRINT_NAVIGATION_VERSION && allowedStates.includes(parsed.state) && allowedActiveTabs.includes(parsed.activeTab) && /^\d+$/.test(String(parsed.attendeeId || '')) && Number.isFinite(Number(parsed.createdAt)) && Number.isFinite(Number(parsed.expiresAt)) && Number(parsed.createdAt) <= now && Number(parsed.expiresAt) >= now && typeof parsed.nonce === 'string' && parsed.nonce.length > 0 && (!allowedAttendeeTabs.length || allowedAttendeeTabs.includes(parsed.attendeeTab) || customTab);
    if (!valid) { storage.removeItem(key); return null; }
    storage.removeItem(key);
    return parsed;
  } catch (error) { storage.removeItem(key); return null; }
}
